import styled from 'styled-components'

const Root = styled.article`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.9em 1.1em;
  display: flex;
  flex-direction: column;
  gap: 0.6em;
  transition: box-shadow 0.18s ease, border-color 0.18s ease;
  direction: rtl;

  &:hover {
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.09);
    border-color: #c8d4de;
  }
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1.4em;
  flex-wrap: wrap;
`

const Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.45em;
  direction: rtl;
`

const ItemLabel = styled.span`
  font-size: 0.72rem;
  color: #8a9ab0;
  font-weight: 500;
  white-space: nowrap;
`

const ItemValue = styled.span`
  font-size: 0.88rem;
  color: #1e2d3d;
  font-weight: 600;
  white-space: nowrap;
`

const ItemIcon = styled.span`
  font-size: 0.82rem;
  color: #5c7fa3;
  width: 1.1em;
  text-align: center;
  flex-shrink: 0;
`

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #edf0f4;
  margin: 0.1em 0;
`

/**
 * Flat card primitive library (shadcn-style composition).
 *
 * Usage:
 *   <CardFlat.Root>
 *     <CardFlat.Row>
 *       <CardFlat.Item>
 *         <CardFlat.ItemIcon><ClockIcon size={13} /></CardFlat.ItemIcon>
 *         <CardFlat.ItemLabel>שעה</CardFlat.ItemLabel>
 *         <CardFlat.ItemValue>14:30</CardFlat.ItemValue>
 *       </CardFlat.Item>
 *     </CardFlat.Row>
 *     <CardFlat.Divider />
 *   </CardFlat.Root>
 */
const CardFlat = {
  Root: Root,
  Row: Row,
  Item: Item,
  ItemLabel: ItemLabel,
  ItemValue: ItemValue,
  ItemIcon: ItemIcon,
  Divider: Divider,
}

export default CardFlat
